import { isApiError } from '@/api/errors';
import { ErrorBanner } from './Alert';
import { Button } from './Button';
import { Forbidden } from './Forbidden';

/** The failure state of a screen's query: "not permitted" for a 403, otherwise the error. */
export function QueryError({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  if (isApiError(error) && error.isForbidden) return <Forbidden />;
  return (
    <ErrorBanner
      error={error}
      action={
        onRetry && (
          <Button size="small" onClick={onRetry}>
            Try again
          </Button>
        )
      }
    />
  );
}
